export default {
  coupon: {
    selectCoupons: '쿠폰 선택',
    tips: '추천 <span class="orange-text">{x}개 쿠폰</span> 선택, <span class="orange-text">{y}</span>',
    couponTips: '<span class="orange-text">{x}개 쿠폰</span> 선택, <span class="orange-text">{y}</span>',
    noSelectedTips: '<span class="orange-text">{x}개 쿠폰</span> 사용 가능',
    changeCard: '결제 카드 변경',
    automaticPay: '자동 결제',
    authorized: '승인됨',
    unauthorized: '승인되지 않음',
  },
  automaticPay: {
    queryRecords: '조회 기록 닫기',
    actionTime: '작업 시간',
    actionType: '작업 유형',
    actionResult: '작업 결과',
    resultDesc: '결과 설명',
    activate: '개통',
    approved: '승인',
    rejected: '반려',
    underReview: '검토 중',
    autoDeductClose: '자동 결제를 해제하시겠습니까?',
    confirmSubmitClose: '자동 결제 해제 신청서를 제출했는지 확인하십시오.',
    closeNotice: '신청이 승인되면 시스템은 더 이상 자동으로 결제를 진행하지 않습니다. 납부 기한을 초과하면 시스템에서 자동으로 수강 취소 처리됩니다.',
    cancelReasonPrompt: '취소 사유를 선택해 주십시오:',
    reasonPrompt: '사유 선택',
    otherReason: '기타',
    closeReasonInput: '자동 결제 해제 사유를 작성해 주십시오.',
    installmentPlan: '할부 결제 계획',
    requestSubmitted: '자동 결제 해제 신청이 제출되었습니다.',
    underReviewNotice: '검토 중인 신청이 있으니 중복 제출하지 마십시오.',
    viewReviewResult: ['검토 결과는 ', ' 에서 확인할 수 있습니다.'],
    autoApproved: '자동 승인됨',
    turnOffAutoDebit: '자동 결제를 해제하시겠습니까?',
    paymentInfo: '결제 상세',
    paymentTime: '결제 시간',
    paymentStatus: '결제 상태',
    paymentResult: '결과 설명',
    paymentApproved: '성공',
    paymentRejected: '실패',
  },
}
